import { MainView } from '@repo/ui/Views';
import { useUser } from '@repo/hooks/useUser';
import { POLICIES, Authorization } from '@/lib/Authorization';
import { FallbackCard } from '@repo/ui/Card';
import UpdateApiKeyForm from '../components/UpdateApiKeyForm';
import { useParams } from 'react-router';
import API_KEYS_SHOW_Q from '../gql/api_keys/show.gql';
import { useQuery } from '@apollo/client/react';
const CreateApiKey = () => {
  const user = useUser();
  const params = useParams();
  const apiKeyId = params.apiKeyId;

  const { loading, data, refetch } = useQuery(API_KEYS_SHOW_Q, {
    variables: {
      id: String(apiKeyId),
    },
  });

  return (
    <MainView title={loading ? 'Update API Key' : `Update API Key: ${data?.apiKey.name}`}>
      <Authorization
        policyCheck={POLICIES['api_keys:update'](user)}
        fallbackView={
          <FallbackCard
            title="No Access"
            description="You do not have the permissions to update API keys."
          />
        }
      >
        {data?.apiKey ? (
          <UpdateApiKeyForm
            apiKeyId={data.apiKey.id}
            name={data.apiKey.name}
            notes={data.apiKey.notes}
            refetch={refetch}
          />
        ) : null}
      </Authorization>
    </MainView>
  );
};

export default CreateApiKey;
